import {
	PatchEndPoint,
	GetEndPoint,
	GetCompanyUsersData,
	GetTransporterTrucksData,
	GetAllEndPoint,
	GetUserCompaniesData,
	GetLoggedInUserAccessData,
	GetPublicMenuData,
	GetCompanyRolesData,
	UpdateUserRolesData,
	getUserRolesData,
	AddUserData,
	ImportUserData,
	UnassignUserData,
	EditUserEndPoint,
	GetTransporterGeneratorsData,
	AddTransporterGeneratorData,
	EditTransporterGeneratorsData,
	DeleteTransporterGeneratorData,
	GetTransporterContactsData,
	AddTransporterContactData,
	EditTransporterContactData,
	DeleteTransporterContactData,
	AddTransporterTruckData,
	DeleteTransporterTruckData,
	EditTransporterTruckData,
	GetAllTemplatesEndPoint,
	AddTemplateEndPoint,
	DeleteTemplateEndPoint,
	DownloadTemplateEndPoint,
	GetBranchesCompanyEndPoint,
	GetCRDetails,
	GetDomainDataEndPoint,
	GetLabelsData,
	GetServicesData,
	GetUserManualsData,
} from "common/constants";
import { makeAuthenticatedRequest } from "../helpers/authenticatedRequest";
import { makeRequest } from "../helpers/makeRequest";

// #region PUBLIC

export const getPublicMenu = async (signal = null) => {
	const url = `${GetPublicMenuData}`;

	const response = await makeRequest(url, {
		method: "GET",
		signal,
	});

	return response;
};

export const getDomainData = async (domainName, signal = null) => {
	const url = `${GetDomainDataEndPoint}/${domainName}`;

	const response = await makeRequest(url, {
		method: "GET",
		signal,
	});

	return response;
}

export const getLabelsData = async (language, signal = null) => {
	const url = `${GetLabelsData}/${language}`;

	const response = await makeRequest(url, {
		method: "GET",
		signal,
	});

	return response;
}

export const getServicesData = async (domainId, pageName, signal = null) => {
	const url = `${GetServicesData}/${domainId}/${pageName}`;

	const response = await makeRequest(url, {
		method: "GET",
		signal,
	});

	return response;
}

export const getUserManualsData = async (signal = null) => {
	const response = await makeRequest(GetUserManualsData, {
		method: "GET",
		signal,
	});

	return response;
}
// #endregion

// #region TABLE COLUMN CONFIGS

export const getTableColumnConfigs = async (domainId, tableName, signal = null) => {
	const filter = `domain_id=eq.${domainId}&table_name=eq.${tableName}&is_active=eq.true`;
	const url = `${GetAllEndPoint}?TableName=tbl_table_column_configs&Filter=${encodeURIComponent(filter)}`;
	const response = await makeAuthenticatedRequest(url, { method: "GET", signal });
	return response;
};

// #endregion

// #region IMPORT DATA TYPE CONFIGS

export const getImportDataTypeConfigs = async (domainId, signal = null) => {
	const filter = `domain_id=eq.${domainId}&is_active=eq.true`;
	const url = `${GetAllEndPoint}?TableName=tbl_import_data_type_configs&Filter=${encodeURIComponent(filter)}`;
	const response = await makeAuthenticatedRequest(url, { method: "GET", signal });
	return response;
};

// #endregion

// #region DATABASE

export const patchDatabase = async (JsonToPatch, signal = null) => {

	const response = await makeAuthenticatedRequest(PatchEndPoint, {
		method: "PATCH",
		body: JSON.stringify(JsonToPatch),
		signal,
	});

	return response.json()
};

export const getDatabaseRecord = async ({ tableName, fieldName, itemId }, signal = null) => {
	const url = `${GetEndPoint}?TableName=${tableName}&FieldName=${fieldName}&FieldValue=${itemId}`;

	const response = await makeAuthenticatedRequest(url, { method: "GET", signal, });

	return response;
};

export const getAllDatabaseRecord = async ({ tableName, condition }, signal) => {
	const url = condition ? `${GetAllEndPoint}?TableName=${tableName}&Filter=${condition}` : `${GetAllEndPoint}?TableName=${tableName}`;

	const response = await makeAuthenticatedRequest(url, {
		method: "GET",
		signal,
	});

	return response;
};

// #endregion

// #region COMPANIES

export const getCompanyDrivers = async (companyId, signal = null) => {
	const url = `${GetCompanyUsersData}tbl_users.tbl_roles_users.roleId=eq.TransporterDriver&&companyId=eq.${companyId}`;
	const response = await makeAuthenticatedRequest(url, { signal });

	return response;
};

// #endregion

// #region WORKFLOWS
export const getWorkflowByID = async ({ applicationID, createdId }, signal = null) => {
	const url = `${GetAllEndPoint}?TableName=${applicationID}&Filter=id=eq.${createdId}`
	const response = await makeAuthenticatedRequest(url, { signal });
	return response;
};

export const getWorkflowTemplates = async (applicationID, signal = null) => {
	const filter = `workflowId=eq.${applicationID}&select=*,templateName:tbl_templates(templateName)`;
	const url = `${GetAllEndPoint}?TableName=tbl_workflow_templates&Filter=${encodeURIComponent(filter)}`;
	const response = await makeAuthenticatedRequest(url, { signal });
	return response;
};

// #endregion

// #region USERS + ROLES + COMPANIES
export const getUserAccessInfo = async (userId, companyId, signal = null) => {
	const url = `${GetLoggedInUserAccessData}/${userId}/${companyId}`;
	const response = await makeAuthenticatedRequest(url, { signal });
	return response;
};

export const getUserCompanies = async (userId, signal = null) => {
	const url = `${GetUserCompaniesData}/${userId}`;
	const response = await makeAuthenticatedRequest(url, { signal });
	return response;
};

export const getCompanyUsers = async (companyId) => {
	const queryString = `tbl_users.tbl_roles_users.companyId=eq.${companyId}&&companyId=eq.${companyId}`;
	const url = `${GetCompanyUsersData}?queryString=${encodeURIComponent(queryString)}`;
	const response = await makeAuthenticatedRequest(url);
	return response;
};

export const getCompanyRoles = async (companyId, signal) => {
	const url = `${GetCompanyRolesData}/${companyId}`;
	const response = await makeAuthenticatedRequest(url, {
		method: "GET",
		signal,
	});
	return response;
};

export const updateUserRoles = async (bodyData, signal) => {
	const url = `${UpdateUserRolesData}`;
	const response = await makeAuthenticatedRequest(url, {
		method: "PUT",
		body: JSON.stringify(bodyData),
		signal,
	});
	return response;
};

export const getUserRoles = async (userId, companyId, signal) => {
	const url = `${getUserRolesData}/${userId}/${companyId}`;
	const response = await makeAuthenticatedRequest(url, {
		method: "GET",
		signal,
	});
	return response;
};

export const addUser = async (companyId, keycloakCompanyId, bodyData) => {
	const url = `${AddUserData}/${companyId}/keycloak/${keycloakCompanyId}/admin/false`;
	const response = await makeAuthenticatedRequest(url, {
		method: "POST",
		body: JSON.stringify(bodyData),
	});
	return response;
};

export const importData = async (table_key, bodyData, companyId, keycloakCompanyId) => {
	console.log(typeof bodyData);
	console.log("body being sent:", bodyData);
	console.log("body being sent:", JSON.stringify(bodyData));
	const url = companyId && keycloakCompanyId
		? `${ImportUserData}/${table_key}/${companyId}/keycloak/${keycloakCompanyId}/admin/false`
		: `${ImportUserData}/${table_key}`;
	const response = await makeAuthenticatedRequest(url, {
		method: "POST",
		body: JSON.stringify(bodyData),
	});
	return response;
};

export const unassignUser = async (userId, companyId, keycloakCompanyId) => {
	const url = `${UnassignUserData}/${userId}/company/${companyId}/keycloak/${keycloakCompanyId}`;
	const response = await makeAuthenticatedRequest(url, {
		method: "DELETE",
	});
	console.log("asd")
	return response;
};

export const editUser = async (userId, bodyData) => {
	const url = `${EditUserEndPoint}/${userId}`;
	const response = await makeAuthenticatedRequest(url, {
		method: "PUT",
		body: JSON.stringify(bodyData),
	});
	return response;
};

// #endregion

// #region GENERATORS

export const getTransporterGeneratorsData = async (companyId, signal = null) => {
	const url = `${GetTransporterGeneratorsData}/${companyId}`;
	const response = await makeAuthenticatedRequest(url, { method: "GET", signal });
	return response;
};

export const addTransporterGenerator = async (companyId, data) => {
	const url = `${AddTransporterGeneratorData}/${companyId}`;
	const response = await makeAuthenticatedRequest(url, { method: "POST", body: JSON.stringify(data) });
	return response;
};

export const editTransporterGenerator = async (generatorId, data) => {
	const url = `${EditTransporterGeneratorsData}/${generatorId}`;
	const response = await makeAuthenticatedRequest(url, { method: "PUT", body: JSON.stringify(data) });

	return response;
};

export const deleteTransporterGenerator = async (generatorId) => {
	const url = `${DeleteTransporterGeneratorData}/${generatorId}`;
	const response = await makeAuthenticatedRequest(url, { method: "DELETE" });
	return response;
};

// #endregion

// #region CONTACTS/DELEGATES

export const getTransporterGeneratorContactsData = async (companyId, signal = null) => {
	const url = `${GetTransporterContactsData}/${companyId}`;
	const response = await makeAuthenticatedRequest(url, { method: "GET", signal });
	return response;
};

export const addTransporterGeneratorContact = async (companyId, data) => {
	const url = `${AddTransporterContactData}/${companyId}`;
	const response = await makeAuthenticatedRequest(url, { method: "POST", body: JSON.stringify(data) });
	return response;
};

export const editTransporterGeneratorContact = async (contactId, data) => {
	const url = `${EditTransporterContactData}/${contactId}`;
	const response = await makeAuthenticatedRequest(url, { method: "PUT", body: JSON.stringify(data) });
	return response;
};

export const deleteTransporterGeneratorContact = async (contactId) => {
	const url = `${DeleteTransporterContactData}/${contactId}`;
	const response = await makeAuthenticatedRequest(url, { method: "DELETE" });
	return response;
};

// #endregion

// #region FLEET

export const getTrucksData = async (companyId, signal = null) => {
	const url = `${GetTransporterTrucksData}/${companyId}`;
	const response = await makeAuthenticatedRequest(url, { signal });
	return response;
};

export const addTransporterTruck = async (relatedCompanyId, data) => {
	const url = `${AddTransporterTruckData}/${relatedCompanyId}`;
	const response = await makeAuthenticatedRequest(url, { method: "POST", body: JSON.stringify(data) });
	return response;
};

export const editTransporterTruck = async (truckId, data) => {
	const url = `${EditTransporterTruckData}/${truckId}`;
	const response = await makeAuthenticatedRequest(url, { method: "PUT", body: JSON.stringify(data) });
	return response;
};

export const deleteTransporterTruck = async (truckId) => {
	const url = `${DeleteTransporterTruckData}/${truckId}`;
	const response = await makeAuthenticatedRequest(url, { method: "DELETE" });
	return response;
};

// #endregion


// #region MOC
export const getCRDetails = async (unn, signal = null) => {
	const url = `${GetCRDetails}?crNationalNumber=${unn}`;
	const response = await makeAuthenticatedRequest(url, {
		method: "GET",
		signal,
	});
	return response;
};
// #endregion


// #region TEMPLATES
export const getTemplatesData = async (signal = null) => {
	const response = await makeAuthenticatedRequest(GetAllTemplatesEndPoint, {
		method: "GET",
		signal,
	});
	return response;
};

export const addTemplate = async (templateName, templateFileExtension, templateFile) => {
	const url = `${AddTemplateEndPoint}/${templateName}/${templateFileExtension}`;
	const response = await makeAuthenticatedRequest(url, {
		method: "POST",
		body: JSON.stringify(templateFile),
	});
	return response;
};

export const deleteTemplate = async (processedTemplateId) => {
	const url = `${DeleteTemplateEndPoint}/${processedTemplateId}`;
	const response = await makeAuthenticatedRequest(url, {
		method: "DELETE",
	});
	return response;
};

export const downloadTemplate = async (templateId) => {
	const url = `${DownloadTemplateEndPoint}/${templateId}`;
	const response = await makeAuthenticatedRequest(url, {
		method: "GET",
	});

	return response;
};
// #endregion

// #region BRANCHES
export const getCompanyBranches = async (companyId, signal = null) => {
	const url = `${GetBranchesCompanyEndPoint}/${companyId}`;
	const response = await makeAuthenticatedRequest(url, { method: "GET", signal });

	return response;
};
// #endregion